import React, { PropsWithChildren } from 'react';
import './RadioSet.css';

const RadioSet: React.FC<PropsWithChildren> = ({ children }) => {
  return <div className="radio-set">{children}</div>;
};

export default RadioSet;
